import { render, staticRenderFns } from "./pop-up.vue?vue&type=template&id=972a92ac&scoped=true&"
import script from "./pop-up.vue?vue&type=script&lang=js&"
export * from "./pop-up.vue?vue&type=script&lang=js&"
import style0 from "./pop-up.vue?vue&type=style&index=0&id=972a92ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972a92ac",
  null
  
)

export default component.exports